module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pa-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.desativarPagamentoPrimeiroTitulo) ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "headline text-xs-center"
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_vm._v("\n                        Caro aluno, você acabou de realizar a sua pré-matrícula, para aproveitar o\n                        "), _c('strong', [_vm._v("período promocional SEM REAJUSTE e com parcelamento diferenciado")]), _vm._v(",\n                        entre em contato pelo WhatsApp (53) 3242-8244 e solicite o primeiro boleto,\n                        lembrando que o primeiro boleto é o que confirma a matrícula,\n                        entre em contato e solicite o seu.\n                      ")])])])], 1) : _vm._e(), _vm._v(" "), (!_vm.desativarPagamentoPrimeiroTitulo) ? _c('v-card', {
    attrs: {
      "flat": "",
      "color": "grey lighten-4"
    }
  }, [(_vm.dadosMatricula.matricula.titulo && !_vm.dadosMatricula.matricula.titulo.ocultarTitulo) ? _c('v-card-text', [_c('h4', {
    staticClass: "title mb-2"
  }, [_vm._v("Linha digitável:")]), _vm._v(" "), (_vm.dadosMatricula.matricula.titulo) ? _c('div', {
    staticClass: "headline text-center"
  }, [(_vm.dadosMatricula.matricula.titulo.linhaDigitavel) ? _c('div', {
    staticClass: "linha-ditavel"
  }, [_vm._v(_vm._s(_vm.dadosMatricula.matricula.titulo.linhaDigitavel))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "formas-pagamento d-flex"
  }, [_c('div', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.imprimirBoleto()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Imprima seu boleto aqui")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(_vm.habilitarPagamentoOnline) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.gerarLinkPagamento()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "pl-1"
  }, [_vm._v("Pague online aqui")])]) : _vm._e()], 1)]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-4 mb-4"
  }), _vm._v("\n                    * O boleto também encontra-se disponível na seção \"Financeiro - Minhas Cobranças\" do menu à esquerda."), _c('br'), _vm._v("\n                    ** O boleto leva algum tempo para ser registrado no banco. Caso não consiga efetuar o pagamento, tente novamente mais tarde."), _c('br'), _vm._v("\n                    *** Caso não abra a janela ao clicar em pagar online, verifique no seu navegador se ele não está bloqueando popups."), _c('br')], 1) : _vm._e(), _vm._v(" "), (_vm.dadosMatricula.matricula.titulo && _vm.dadosMatricula.matricula.titulo.ocultarTitulo) ? _c('v-card-text', [_c('div', {
    staticClass: "headline text-xs-center"
  }, [_c('div', {
    staticClass: "pa-4"
  }, [_vm._v("\n                        Acesse a seção "), _c('strong', [_vm._v("Financeiro - Minhas Cobranças")]), _vm._v(" no menu a esquerda ou "), _c('router-link', {
    attrs: {
      "to": "/financeiro/minhas-cobrancas"
    }
  }, [_vm._v("clique aqui")]), _vm._v(" para visualizar,\n                        emitir e/ou pagar online seus boletos de matrícula.\n                      ")], 1)])]) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-header"
  }, [_c('navigation-buttons', {
    attrs: {
      "show-previous": false,
      "show-next": false,
      "next-click": _vm.fechar,
      "disable-next": false,
      "close": true
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "80%"
    },
    model: {
      value: (_vm.mostrarModalPdf),
      callback: function($$v) {
        _vm.mostrarModalPdf = $$v
      },
      expression: "mostrarModalPdf"
    }
  }, [_c('v-card', {
    staticClass: "modal-pdf"
  }, [_c('v-card-text', [_c('iframe', {
    attrs: {
      "src": _vm.pdfBase64
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalPdf = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": _vm.isMobileSize ? '90%' : '50%'
    },
    model: {
      value: (_vm.mostrarModalPagarOnline),
      callback: function($$v) {
        _vm.mostrarModalPagarOnline = $$v
      },
      expression: "mostrarModalPagarOnline"
    }
  }, [_c('v-card', [_c('v-container', [_c('h3', {
    staticClass: "pb-3",
    class: {
      'display-1': !_vm.isMobileSize
    }
  }, [_vm._v("\n          Pagamento online\n        ")]), _vm._v(" "), _c('div', {
    class: {
      'body-1': _vm.isMobileSize, 'subheading': !_vm.isMobileSize
    }
  }, [_c('p', [_vm._v("\n            O pedido nº "), _c('strong', [_vm._v(_vm._s(_vm.refPedido))]), _vm._v(" no valor de\n            "), _c('strong', [_vm._v("R$ " + _vm._s(_vm._f("currencyEnToBr")(_vm.valorPedido)))]), _vm._v(" foi gerado com sucesso. Caso não tenha aberto uma\n            janela no seu navegador, clique no link abaixo para efetuar o pagamento.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('strong', [_vm._v("Link para pagamento:")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.urlPagamento,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.urlPagamento))])])])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalPagarOnline = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50e48224!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/Pagamento.vue
// module id = 542
// module chunks = 2